import { render, staticRenderFns } from "./nutritionMealDialogSelectedRecipe.vue?vue&type=template&id=778959f9&scoped=true"
import script from "./nutritionMealDialogSelectedRecipe.vue?vue&type=script&lang=js"
export * from "./nutritionMealDialogSelectedRecipe.vue?vue&type=script&lang=js"
import style0 from "./nutritionMealDialogSelectedRecipe.vue?vue&type=style&index=0&id=778959f9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778959f9",
  null
  
)

export default component.exports